package com.sweetlime.bingeamigo.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Genre(
    val id: Int,
    val name: String
)

@Serializable
data class SeasonSummary(
    val id: Int,
    val name: String,
    val overview: String = "",
    @SerialName("air_date")
    val airDate: String = "",
    @SerialName("episode_count")
    val episodeCount: Int = 0,
    @SerialName("poster_path")
    val posterPath: String? = null,
    @SerialName("season_number")
    val seasonNumber: Int = 0,
    @SerialName("vote_average")
    val voteAverage: Double = 0.0
)

@Serializable
data class TvShowDetail(
    val id: Int,
    val name: String,
    val overview: String,
    val adult: Boolean = false,
    @SerialName("backdrop_path")
    val backdropPath: String? = null,
    val genres: List<Genre> = emptyList(),
    @SerialName("original_language")
    val originalLanguage: String = "",
    @SerialName("original_name")
    val originalName: String = "",
    val popularity: Double = 0.0,
    @SerialName("poster_path")
    val posterPath: String? = null,
    @SerialName("first_air_date")
    val firstAirDate: String = "",
    @SerialName("last_air_date")
    val lastAirDate: String = "",
    @SerialName("vote_average")
    val voteAverage: Double = 0.0,
    @SerialName("vote_count")
    val voteCount: Int = 0,
    @SerialName("number_of_episodes")
    val numberOfEpisodes: Int = 0,
    @SerialName("number_of_seasons")
    val numberOfSeasons: Int = 0,
    val seasons: List<SeasonSummary> = emptyList(),
    val status: String = "",
    val tagline: String = "",
    @SerialName("episode_run_time")
    val episodeRunTime: List<Int> = emptyList(),
    @SerialName("in_production")
    val inProduction: Boolean = false
)